module.exports = __webpack_public_path__ + "img/the-widsith.c2e83c09.webp";